export const procedureWh = {
    namespaced: true,
    state: {
        procedureWhModel: {},
        procedureWh: {},
        lstMaterial:[],
        lstType:[],
        lstMotherDay:[],
        lstChildrenDay:[],
        isView: "1",
    },
    getters: {
        procedureWhModel(state) {
            return state.procedureWhModel
        },
        procedureWh(state) {
            return state.procedureWh
        },
        lstMaterial(state) {
            return state.lstMaterial
        },
        lstType(state) {
            return state.lstType
        },
        lstMotherDay(state) {
            return state.lstMotherDay
        },
        lstChildrenDay(state) {
            return state.lstChildrenDay
        },
        isView(state) {
            if(state.isView != undefined){
                return state.isView
            } else{
                return "1";
            }

        },
    },
    mutations: {
        setProcedureWhModel(state, procedureWhModel) {
            if (procedureWhModel != undefined) {
                state.procedureWhModel = procedureWhModel;
            } else {
                state.procedureWhModel = {};
            }
        },
        setProcedureWh(state, procedureWh) {
            if (procedureWh != undefined) {
                state.procedureWh = procedureWh;
            } else {
                state.procedureWh = {};
            }
        },
        setLstMaterial(state, lstMaterial) {
            if (lstMaterial != undefined) {
                state.lstMaterial = lstMaterial;
            } else {
                state.lstMaterial = [];
            }
        },
        setLstType(state, lstType) {
            if (lstType != undefined) {
                state.lstType = lstType;
            } else {
                state.lstType = [];
            }
        },

        setLstMotherDay(state, lstMotherDay) {
            if (lstMotherDay != undefined) {
                state.lstMotherDay = lstMotherDay;
            } else {
                state.lstMotherDay = [];
            }
        },
        updateMotherDay(state, {index, item}) {
            state.lstMotherDay[index] = item
        },
        setLstChildrenDay(state, lstChildrenDay) {
            if (lstChildrenDay != undefined) {
                state.lstChildrenDay = lstChildrenDay;
            } else {
                state.lstChildrenDay = [];
            }
        },
        updateChildrenDay(state, {index, item}) {
            state.lstChildrenDay[index] = item
        },

        setIsView(state, isView) {
            state.isView = isView
        },

    },
    actions: {
        setProcedureWhModel({commit}, procedureWhModel) {
            commit("setProcedureWhModel", procedureWhModel);
            commit("setProcedureWh", procedureWhModel['procedureWh']);
            commit("setLstMaterial", procedureWhModel['lstMaterial']);
            commit("setLstType", procedureWhModel['lstType']);
            commit("setLstMotherDay", procedureWhModel['lstMotherDay']);
            commit("setLstChildrenDay", procedureWhModel['lstChildrenDay']);

        }
    }

}